/**
 * Die Tastenkuerzel der Bewertungsseite -- an EINER Stelle.
 *
 * Warum das hier liegt: die Liste stand bis hierher doppelt, einmal englisch im
 * Info-Popover von MessagesList.vue und einmal deutsch als Textblock im Editor
 * von MessageCard.vue. Beide waren unvollstaendig und widersprachen sich; J/K,
 * das Verschlucken von Tab und Esc zum Schliessen des Popovers standen in
 * keiner von beiden. Wer ein Kuerzel aendert, aendert es jetzt hier -- und die
 * Oberflaeche zieht nach.
 *
 * KUERZEL wird fuer die Tooltips an den einzelnen Bedienelementen gebraucht,
 * SHORTCUT_GRUPPEN fuer die vollstaendige Uebersicht im Info-Popover.
 */

/**
 * Einzelkuerzel fuer Tooltips direkt am Bedienelement.
 *
 * ACHTUNG, am 20.08. um vier Eintraege gekuerzt (schliessen, kommentar,
 * dimensionZurueck, alleAufNull). Sie hatten NULL Verwender: die Kuerzel
 * selbst gibt es weiter, aber sie stehen nur in SHORTCUT_GRUPPEN darunter.
 *
 * Damit bleibt eine Doppelung: jede Taste, die hier steht, steht auch dort
 * noch einmal -- und diese Datei behauptet in ihrem Kopf, die Kuerzel
 * staenden 'an EINER Stelle'. Aufloesen laesst sich das nicht ohne Umbau,
 * denn SHORTCUT_GRUPPEN braucht die Tasten EINZELN fuer die .kbd-Kappen.
 * Deshalb wird die Doppelung jetzt wenigstens BEWACHT statt nur beklagt:
 * test_shortcuts_konsistenz.py verlangt, dass jeder Wert von hier in
 * SHORTCUT_GRUPPEN wiederzufinden ist.
 */
export const KUERZEL = {
  freigeben: "Ctrl+A",
  neuBewerten: "Ctrl+R",
  speichern: "Shift+Enter",
  verwerfen: "Shift+Esc",
  editorOeffnen: "Enter",
  dimensionVor: "Tab",
  merken: "M",
};

/**
 * Vollstaendige Uebersicht, gruppiert nach Geltungsbereich.
 *
 * `tasten` ist bewusst ein Array: die Oberflaeche setzt jede Taste in eine
 * eigene Tastenkappe (.kbd), statt einen Fliesstext mit <b> zu bauen.
 */
export const SHORTCUT_GRUPPEN = [
  {
    titel: "In der Liste",
    eintraege: [
      { tasten: ["↑", "↓"], wirkung: "aktive Nachricht wechseln" },
      { tasten: ["J", "K"], wirkung: "dasselbe, ohne die Hand zu bewegen" },
      { tasten: ["Ctrl", "Shift", "↑/↓"], wirkung: "Liste scrollen, ohne die Auswahl zu ändern" },
    ],
  },
  {
    titel: "Aktive Nachricht",
    eintraege: [
      { tasten: ["Ctrl", "A"], wirkung: "freigeben" },
      { tasten: ["Ctrl", "R"], wirkung: "neu bewerten (auch ohne Freigabe) — löscht die vorhandenen Bewertungen" },
      { tasten: ["Ctrl", "↑/↓"], wirkung: "Nachrichtentext scrollen" },
      { tasten: ["Shift", "0"], wirkung: "alle Bewertungen auf 0 (Kommentare bleiben)" },
      { tasten: ["M"], wirkung: "für einen Vergleichssatz merken (oder vergessen)" },
    ],
  },
  {
    titel: "Bewertungsdimensionen",
    eintraege: [
      { tasten: ["Tab"], wirkung: "nächste Dimension — speichert vorher, wenn nötig" },
      { tasten: ["Shift", "Tab"], wirkung: "vorige Dimension" },
      { tasten: ["←", "→"], wirkung: "Auswahl verschieben (bei geschlossenem Editor)" },
      { tasten: ["Enter"], wirkung: "Editor für die ausgewählte Dimension öffnen" },
    ],
  },
  {
    titel: "Im Editor",
    eintraege: [
      { tasten: ["0", "1", "2", "3"], wirkung: "Wert setzen" },
      { tasten: ["Shift", "1/2/3"], wirkung: "negativer Wert" },
      { tasten: ["←", "→"], wirkung: "Wert um 1 verringern / erhöhen" },
      { tasten: ["C"], wirkung: "in das Kommentarfeld springen" },
      { tasten: ["Shift", "Enter"], wirkung: "speichern und schließen" },
      { tasten: ["Shift", "Esc"], wirkung: "verwerfen und schließen" },
      { tasten: ["Esc"], wirkung: "schließen (nur ohne offene Änderungen)" },
    ],
  },
];

/**
 * Die Skala, auf die jede Werteingabe geklemmt wird.
 *
 * Nur zur ANZEIGE hier -- die verbindliche Fassung steht in MessageCard.vue
 * (WERT_MIN / WERT_MAX), direkt neben dem Code, der klemmt.
 */
export const SKALA_TEXT = "−3 bis +3";
